<template>
    <div class="integration-card">
        <template v-if="!isLoading">
            <div class="content">
                <div class="form-group">
                    <label class="label">API Ключ</label>
                    <BaseTextInput
                        view="primary"
                        :value="apiKey"
                        placeholder="Введите API Key"
                        @input="onInputAttribute($event, 'apiKey')"
                    />
                </div>

                <div class="form-group">
                    <label class="label">Секретный ключ</label>
                    <BaseTextInput
                        view="primary"
                        :value="secretKey"
                        placeholder="Введите Secret Key"
                        @input="onInputAttribute($event, 'secretKey')"
                    />
                </div>

                <div class="form-group">
                    <label class="label">Комментарий</label>
                    <BaseTextInput
                        view="primary"
                        :value="comment"
                        placeholder="Введите комментарий"
                        @input="onInputAttribute($event, 'comment')"
                    />
                </div>
            </div>

            <div class="actions">
                <BaseButton
                    v-if="!isNew"
                    view="primary"
                    form="oval"
                    @click="onUpdateItem"
                >
                    Изменить
                </BaseButton>

                <BaseButton
                    v-if="isNew"
                    view="secondary"
                    form="oval"
                    @click="onAddItem"
                >
                    Добавить
                </BaseButton>

                <BaseButton
                    v-if="!isNew"
                    view="primary"
                    form="oval"
                    class="btn-delete"
                    @click="$emit('removeItem', id)"
                >
                    <IconTrash class="icon" :width="20" :height="20" />
                </BaseButton>
            </div>
        </template>

        <template v-else>
            <IntegrationCardSkeleton/>
        </template>
    </div>
</template>

<script>
import BaseTextInput from "@/components/Base/BaseTextInput.vue";
import BaseButton from "@/components/Base/BaseButton.vue";
import IntegrationCardSkeleton from "@/components/Integrations/IntegrationCardSkeleton.vue";
import IconTrash from "../Icons/IconTrash.vue";
export default {
    name: "IntegrationTelegramCard",
    components: {
        BaseTextInput,
        BaseButton,
        IntegrationCardSkeleton,
        IconTrash
    },
    props: {
        id: {
            type: Number,
            default: 0,
        },
        apiKey: {
            type: String,
            default: null,
        },
        secretKey: {
            type: String,
            default: null,
        },
        comment: {
            type: String,
            default: null,
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        isNew() {
            return this.id === 0;
        }
    },

    methods: {
        onInputAttribute(value, attribute) {
            this.$emit("inputAttribute", {value, attribute});
        },

        onAddItem() {
            this.$emit("addItem");
        },

        onUpdateItem() {
            this.$emit("updateItem");
        }
    }
};
</script>

<style lang="scss" scoped>
.integration-card {
  width: 250px;
  min-width: 250px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1.5rem;
  color: #1f2937;
  font-size: 0.95rem;
  line-height: 1.5;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  transition: 0.3s ease;

  .content {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .form-group {
    display: flex;
    flex-direction: column;

    .label {
      font-size: 0.875rem;
      font-weight: 500;
      margin-bottom: 0.4rem;
      color: #333;
    }
  }

  .actions {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 1.5rem;

    button {
      height: 40px;
      font-size: 0.875rem;
      border-radius: 9999px;
      white-space: nowrap;
    }

    .btn-primary,
    .btn-secondary {
      flex: 1;
    }

    .btn-delete {
      width: 40px;
      padding: 0;
      color: #e3342f;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

</style>
